import { AdsHandlerActionTypes } from './adsHandler.types';

const adsHandlerPagesRequest = () => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_PAGES_REQUEST,
});

const adsHandlerPagesSuccess = payload => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_PAGES_SUCCESS,
  payload,
});

const adsHandlerPagesFailure = () => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_PAGES_FAILURE,
});

const adsHandlerDraftsRequest = () => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_DRAFTS_REQUEST,
});

const adsHandlerDraftsSuccess = payload => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_DRAFTS_SUCCESS,
  payload,
});

const adsHandlerDraftsFailure = () => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_DRAFTS_FAILURE,
});

const unlinkAccountRequest = () => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_UNLINK_ACCOUNT_REQUEST,
});

const unlinkAccountSuccess = () => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_UNLINK_ACCOUNT_SUCCESS,
});

const unlinkAccountFailure = () => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_UNLINK_ACCOUNT_FAILURE,
});

const unlinkAccountLoading = bool => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_UNLINK_ACCOUNT_LOADING,
  payload: bool,
});

const adsHandlerInsightsRequest = params => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_INSIGHTS_REQUEST,
  payload: params,
});

const adsHandlerInsightsSuccess = payload => ({
  type: AdsHandlerActionTypes.ADS_HANDLER_INSIGHTS_SUCCESS,
  payload,
});


const actions = {
  pages: {
    request: adsHandlerPagesRequest,
    success: adsHandlerPagesSuccess,
    failure: adsHandlerPagesFailure,
  },
  drafts: {
    request: adsHandlerDraftsRequest,
    success: adsHandlerDraftsSuccess,
    failure: adsHandlerDraftsFailure,
  },
  unlinkAccount: {
    unlinkAccountRequest,
    unlinkAccountSuccess,
    unlinkAccountFailure,
    unlinkAccountLoading,
  },
  insights: {
    request: adsHandlerInsightsRequest,
    success: adsHandlerInsightsSuccess,
  },
};

export default actions;
